/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InputStreamSource } from '../../models/input-stream-source';

export interface GetOperatingLicense$Params {
  merchantId: string;
  siteId: string;
}

export function getOperatingLicense(http: HttpClient, rootUrl: string, params: GetOperatingLicense$Params, context?: HttpContext): Observable<StrictHttpResponse<InputStreamSource>> {
  const rb = new RequestBuilder(rootUrl, getOperatingLicense.PATH, 'get');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.path('siteId', params.siteId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InputStreamSource>;
    })
  );
}

getOperatingLicense.PATH = '/merchants/{merchantId}/sites/{siteId}/operating-license';
